import React from "react";
import "@/App.css";
import "react-katex/node_modules/katex/dist/katex.min.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import Classes from "@/pages/Classes";
import ChapterList from "@/pages/ChapterList";
import ChapterDetail from "@/pages/ChapterDetail";
import ChapterNotes from "@/pages/ChapterNotes";
import { VisitTracker } from "@/components/VisitTracker";
import Learn from "@/pages/Learn";
import LearnCourse from "@/pages/LearnCourse";
import LearnUnit from "@/pages/LearnUnit";
import LearnLesson from "@/pages/LearnLesson";
import LearnSkill from "@/pages/LearnSkill";
import LearnSkillPractice from "@/pages/LearnSkillPractice";
import Topics from "@/pages/Topics";
import TopicDetail from "@/pages/TopicDetail";
import TopicPractice from "@/pages/TopicPractice";
import DailyQuiz from "@/pages/DailyQuiz";
import MentalMaths from "@/pages/MentalMaths";
import Tutor from "@/pages/Tutor";
import Dashboard from "@/pages/Dashboard";
import PracticeTest from "@/pages/PracticeTest";
import Worksheet from "@/pages/Worksheet";
import SamplePapers from "@/pages/SamplePapers";
import FullMock from "@/pages/FullMock";
import AdvancedWorksheets from "@/pages/AdvancedWorksheets";
import Formulas from "@/pages/Formulas";
import Admin from "@/pages/Admin";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: detect Emergent OAuth callback during render, not in useEffect
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/classes" element={<Classes />} />
        <Route path="/classes/:classId" element={<ChapterList />} />
        <Route path="/chapters/:chapterId" element={<ChapterDetail />} />
        <Route path="/chapters/:chapterId/notes" element={<ChapterNotes />} />
        <Route path="/learn" element={<Learn />} />
        <Route path="/learn/:courseId" element={<LearnCourse />} />
        <Route path="/learn/unit/:unitId" element={<LearnUnit />} />
        <Route path="/learn/lesson/:lessonId" element={<LearnLesson />} />
        <Route path="/learn/skill/:skillId" element={<LearnSkill />} />
        <Route path="/learn/skill/:skillId/practice" element={<LearnSkillPractice />} />
        <Route path="/topics" element={<Topics />} />
        <Route path="/topics/:slug" element={<TopicDetail />} />
        <Route path="/topics/:slug/practice" element={<TopicPractice />} />
        <Route path="/quiz" element={<DailyQuiz />} />
        <Route path="/mental" element={<MentalMaths />} />
        <Route path="/tutor" element={<Tutor />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/practice/:chapterId" element={<PracticeTest />} />
        <Route path="/worksheet/:chapterId" element={<Worksheet />} />
        <Route path="/sample-papers/:classId" element={<SamplePapers />} />
        <Route path="/full-mock/:classId" element={<FullMock />} />
        <Route path="/worksheets/:classId" element={<AdvancedWorksheets />} />
        <Route path="/formulas" element={<Formulas />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <VisitTracker />
        <Toaster theme="dark" position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
